import React from 'react'

export const containerDataTestID = 'description-cell-container'

interface DescriptionCellProps {
  readonly rowData: {
    readonly description: string
  }
}

export function DescriptionCell({
  rowData: { description }
}: DescriptionCellProps) {
  return <div data-testid={containerDataTestID}>{description}</div>
}
